import { OnboardingField } from '@/bpc/components/OnboardingFieldComponent/OnboardingField';
import { OnboardingGroup } from '@/bpc/components/OnboardingGroupComponent/OnboardingGroup';

export const findFieldByAbsolutePath = (
  group: OnboardingGroup,
  absolutePath: string,
): OnboardingField => {
  let field: OnboardingField | undefined;

  group.fields.forEach(fields => {
    field = fields.find(f => f.absolutePath && f.absolutePath.includes(absolutePath));
  });

  if (!field) {
    throw Error(`field for ${absolutePath} is missing`);
  } else {
    return field;
  }
};
